/**
 * File: apps/qbench-cp/reactapp/src/shared/hooks/misc/useIsMobile.js
 *
 * Purpose: Reports whether the current viewport matches a media query derived from the theme's
 *     desktop breakpoint.
 *
 * Scope: mobile/desktop viewport detection.
 *
 * Tags: customer-portal
 *
 * Overview: Wraps react-responsive's useMediaQuery, passing a query string built from the
 *     theme's device.desktop breakpoint value.
 *
 * Exports: default useIsMobile hook.
 */

import { useMediaQuery } from 'react-responsive';

/**
 * Hook for detecting mobile
 */
const useIsMobile = () => {
  return useMediaQuery({ query: `${({ theme }) => theme.device.desktop}` });
};

export default useIsMobile;
